import API from './jsonapi-constants'

export const CONSTANTS = {
  ATTRIBUTE: {
    ID: 'attribute.id',
    DOMAIN: 'attribute.domain',
    TYPE: 'attribute.type',
    CODE: 'attribute.code',
    LABEL: 'attribute.label',
    STATUS: 'attribute.status',
    POSITION: 'attribute.position',
    NAME: 'attribute.dp.name',
  },
  RELATIONSHIP: {
    ID: 'attribute.lists.id',
    DOMAIN: 'attribute.lists.domain',
    REFID: 'attribute.lists.refid',
    DATESTART: 'attribute.lists.datestart',
    DATEEND: 'attribute.lists.dateend',
    CONFIG: 'attribute.lists.config',
    POSITION: 'attribute.lists.position',
    STATUS: 'attribute.lists.status',
    TYPE: 'attribute.lists.type',
  },
}

export const PATHS = {
  ID: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.ID],
  DOMAIN: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.DOMAIN],
  TYPE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.TYPE],
  CODE: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.CODE],
  LABEL: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.LABEL],
  STATUS: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.STATUS],
  POSITION: [API.ATTRIBUTES, CONSTANTS.ATTRIBUTE.POSITION],
  RELATIONSHIP_ID: [API.ATTRIBUTES, CONSTANTS.RELATIONSHIP.ID],
  RELATIONSHIP_DOMAIN: [API.ATTRIBUTES, CONSTANTS.RELATIONSHIP.DOMAIN],
  RELATIONSHIP_TYPE: [API.ATTRIBUTES, CONSTANTS.RELATIONSHIP.TYPE],
  RELATIONSHIP_CODE: [API.ATTRIBUTES, CONSTANTS.RELATIONSHIP.CODE],
  RELATIONSHIP_LABEL: [API.ATTRIBUTES, CONSTANTS.RELATIONSHIP.LABEL],
  RELATIONSHIP_STATUS: [API.ATTRIBUTES, CONSTANTS.RELATIONSHIP.STATUS],
  RELATIONSHIP_POSITION: [API.ATTRIBUTES, CONSTANTS.RELATIONSHIP.POSITION],
}

export default {
  ...CONSTANTS,
  PATHS,
}
